import React from "react"
import { Dropdown as AntDropdown } from "antd"
import PropTypes from "prop-types"
import "./Dropdown.scss"

const Dropdown = ({
  items,
  trigger = "click",
  buttonLayout = "vertical",
  placement = "bottomRight",
  width,
  overlayClassName,
  children,
  ...dropdownProps // title
}) => {
  const renderChildren = () => {
    if (children) return children
    return buttonLayout === "vertical" ? <i className="fal fa-ellipsis-v" /> : <i className="fal fa-ellipsis-h" />
  }

  // popover classes
  const overlayClassNames = ["my-prime-dashboard-menu"]
  if (overlayClassName) overlayClassNames.push(overlayClassName)

  return (
    <>
      <AntDropdown
        trigger={trigger}
        placement={placement}
        overlayStyle={width && { width }}
        overlayClassName={overlayClassNames.join(" ")}
        {...dropdownProps}
        menu={{ items }}
      >
        <div className="menu-ellipsis">{renderChildren()}</div>
      </AntDropdown>
    </>
  )
}

Dropdown.propTypes = {
  buttonLayout: PropTypes.oneOf(["vertical", "horizontal"]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
  trigger: PropTypes.oneOf(["click", "hover", "contextMenu"]),
  overlayClassName: PropTypes.string,
  width: PropTypes.number,
  children: PropTypes.node,
}

export default Dropdown
